import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Box, Button, Card, Container, Grid, Stack, Table, TableBody, TableContainer, Typography } from '@mui/material';
// components
import moment from 'moment';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ButtonAction from 'src/components/Button.js/SaveButton';
import EmtyData from 'src/components/emty-data';
import Iconify from 'src/components/iconify/Iconify';
import ComboBox from 'src/components/Input/ComboBox';
import DatePickerValue from 'src/components/Input/DatePickerValue';
import TextInput from 'src/components/Input/TextInput';
import Loader from 'src/components/loader/loader';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import ChangeQtyRequestTakeDeviceModal from 'src/pages/list-take-device/modal/ChangeQtyRequestTakeDevice';
import RejectRequestTakeDeviceModal from 'src/pages/list-take-device/modal/RejectRequestTakeDevice';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ItemListTakeDevice from './ItemListTakeDevice';
import ConfirmFixDeviceModel from './modal/ConfirmFixDevice';
import RequestFixDeviceModel from './modal/RequestFixDevice';
import ReturnDevice from './modal/ReturnDevice';
import ChangeDeviceTakeOrBorrow from '../RequestDevices/modal/ChangeDeviceTakeOrBorrow';
import TakeDevice from '../RequestDevices/modal/TakeDevice';

// ----------------------------------------------------------------------
const STATUS_COLOR = {
    0: 'secondary',
    1: 'primary',
    2: 'info',
    3: 'error',
    4: 'success',
    5: 'warning',
    6: 'info',
    8: 'warning',
    9: 'success',
    10: 'secondary',
    11: 'info',
    12: 'error',
    13: 'success',
};
export default function ListTakeDevice({ device_cd = '' }) {
    // region variables
    const { t } = useTranslation();
    const getRef = useRef();
    const [visible, setVisible] = useState(false);
    const [visibleRefund, setVisibleRefund] = useState(false);
    const [visibleApprove, setVisibleApprove] = useState(false);
    const [visibleReject, setVisibleReject] = useState(false);
    const [visibleRequestFixDevice, setVisibleRequestFixDevice] = useState(false);
    const [visibleConfirmFixDevice, setVisibleConfirmFixDevice] = useState(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const params = useParams();
    const tableRef = useRef(null);
    const lastIdRef = useRef(0);
    const dataRef = useRef(null);
    const [totalData, setTotalData] = useState(0);
    const [openChangeRequestDevice, setOpenChangeRequestDevice] = useState(false);
    const [openTakeDevice, setOpenTakeDevice] = useState(false);

    const valueSearch = useRef({
        key: '',
        startDay: moment().subtract(1, 'months').format('YYYYMMDD'),
        endDay: moment().format('YYYYMMDD'),
        status: 'all',
    });
    const handleOnChange = (e, key) => {
        valueSearch.current[key] = e;
    };
    const user = glb_sv.userInfo;
    const isAdmin = user?.group_user === '1' || user?.group_user === '2';
    // region ARR_STATUS
    const ARR_STATUS = [
        { label: t('all'), value: 'all' },
        { label: t('taked'), value: '0' },
        { label: t('requestRefund'), value: '1' },
        { label: t('requestUpdateAmountTake'), value: '2' },
        { label: t('rejected'), value: '3' },
        { label: t('approved'), value: '4' },
        { label: t('request_grinding_device'), value: '5' },
        { label: t('admin_progresing'), value: '7' },
        { label: t('confirm_grinding_device'), value: '6' },
        { label: t('admin_is_under_review'), value: '8' },
        { label: t('success'), value: '9' },
    ];
    // region TABLE_HEAD
    const TABLE_HEAD = [
        { id: '', label: '', alignRight: false },
        { id: '', label: '#', alignRight: false },
        { id: 'status', label: t('status'), alignRight: false },
        { id: 'device', label: t('device'), alignRight: false },
        { id: 'info', label: t('info'), alignRight: false },
        { id: 'taker', label: t('taker'), alignRight: false },
        { id: 'user_assign_nm', label: t('requester_name_device'), alignRight: false },
        { id: 'day_get', label: t('day_get'), alignRight: false },
        { id: 'quantity_category', label: t('quantity_category'), alignRight: false },
        { id: 'qtyRequest', label: t('qtyRequest'), alignRight: false },
        { id: 'qtyInventory', label: t('qtyInventory'), alignRight: false },
        { id: 'noteReturnChange', label: t('noteReturnChange'), alignRight: false },
        { id: 'userRequest', label: t('userRequest'), alignRight: false },
        { id: 'dateRequest', label: t('dateRequest'), alignRight: false },
        { id: 'userApproveOrReject', label: t('userApproveOrReject'), alignRight: false },
        { id: 'dateApproveReject', label: t('dateApproveReject'), alignRight: false },
        { id: 'reason', label: t('reason'), alignRight: false },
        { id: 'note_grinding', label: t('note_grinding'), alignRight: false },
        { id: 'new_place', label: t('new_place'), alignRight: false },
        { id: 'date_repairing', label: t('date_fixing'), alignRight: false },
        { id: 'price_repaired', label: t('price_repaired'), alignRight: false },
        { id: 'note_', label: t('note_'), alignRight: false },
        { id: 'code_device', label: t('code_device'), alignRight: false },
        { id: 'action', label: '', alignRight: false, stickyEnd: true },
    ];

    // region useEffect getData
    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    // region getData
    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [
            valueSearch.current.status,
            9999999999999,
            valueSearch.current.startDay,
            valueSearch.current.endDay,
            valueSearch.current.key,
        ];
        sendRequest(serviceList.get_list_etk_by_status, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    // region getDataResult
    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataRes = message.proc_data.rows[0]?.o_1 || [];
            if (dataRes?.length) lastIdRef.current = dataRes[dataRes.length - 1].id;
            setTableData(dataRes);
            setTotalData(message.proc_data.rowTotal || 0);
            console.log('dataRes', dataRes);
        }
    };

    // region getDataNext
    const getDataNext = (lastId = lastIdRef.current) => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [
            valueSearch.current.status,
            lastId,
            valueSearch.current.startDay,
            valueSearch.current.endDay,
            valueSearch.current.key,
        ];
        sendRequest(serviceList.get_list_etk_by_status, InVal, getDataNextResult, true, timeOutFunct, 40000);
    };

    // region getDataNextResult
    const getDataNextResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataRes = message.proc_data.rows[0]?.o_1 || [];
            if (dataRes?.length) lastIdRef.current = dataRes[dataRes.length - 1].id;
            setTableData([...tableData, ...dataRes]);
            setTotalData(message.proc_data.rowTotal || 0);
            console.log('dataRes', dataRes);
        }
    };

    // region timeOutFunct
    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    // region onDownload Excel
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t('ds_lay_tb'),
        sheet: t('ds_lay_tb'),
    });

    return (
        <>
            {!device_cd && (
                <Helmet>
                    <title> {t('ds_lay_tb')} </title>
                </Helmet>
            )}

            <Container>
                {/* Yêu cầu hoàn trả */}
                <ReturnDevice
                    visible={visibleRefund}
                    setVisible={setVisibleRefund}
                    title={'refundTakeDevice'}
                    mesages={'refundTakeDeviceMessage'}
                    paramsApi={[dataRef.current?.id || 0, '1', 0, '0']}
                    titleButtonConfirm="confirm"
                    typeButtonConfirm="confirm"
                    serviceApi={serviceList.request_change_status}
                    callBackFunct={() => {
                        setVisibleRefund(false);
                        getData();
                    }}
                ></ReturnDevice>
                {/* Duyệt */}
                <ConfirmModal
                    visible={visibleApprove}
                    setVisible={setVisibleApprove}
                    title={'approveTakeDevice'}
                    mesages={'approveTakeDeviceMessage'}
                    titleButtonConfirm="confirm"
                    typeButtonConfirm="confirm"
                    callBackFunct={() => {
                        setVisibleApprove(false);
                        getData();
                    }}
                    paramsApi={[dataRef.current?.id || 0]}
                    serviceApi={serviceList.approve_request}
                ></ConfirmModal>
                {/* Yêu cầu thay đổi số lương */}
                <ChangeQtyRequestTakeDeviceModal
                    visible={visible}
                    setVisible={setVisible}
                    data={dataRef.current}
                    callBackFunct={() => {
                        setVisible(false);
                        getData();
                    }}
                ></ChangeQtyRequestTakeDeviceModal>
                {/* Từ chối */}
                <RejectRequestTakeDeviceModal
                    visible={visibleReject}
                    setVisible={setVisibleReject}
                    callBackFunct={() => {
                        setVisibleReject(false);
                        getData();
                    }}
                    data={dataRef.current}
                ></RejectRequestTakeDeviceModal>
                {/* Yêu cầu mài */}
                <RequestFixDeviceModel
                    visible={visibleRequestFixDevice}
                    setVisible={setVisibleRequestFixDevice}
                    callBackFunct={() => {
                        setVisibleRequestFixDevice(false);
                        getData();
                    }}
                    idPermission={parseInt(params.idPermission)}
                    data={dataRef.current}
                />
                {/* Xác nhận mài */}
                <ConfirmFixDeviceModel
                    visible={visibleConfirmFixDevice}
                    setVisible={setVisibleConfirmFixDevice}
                    callBackFunct={() => {
                        setVisibleConfirmFixDevice(false);
                        getData();
                    }}
                    idPermission={parseInt(params.idPermission)}
                    data={dataRef.current}
                />
                {/* Yêu cầu cấp lại thiết bị */}
                <ChangeDeviceTakeOrBorrow
                    visible={openChangeRequestDevice}
                    setVisible={setOpenChangeRequestDevice}
                    callBackFunct={() => {
                        setOpenChangeRequestDevice(false);
                        getData();
                    }}
                    idPermission={parseInt(params.idPermission)}
                    data={dataRef.current}
                />
                <TakeDevice
                    visible={openTakeDevice}
                    setVisible={setOpenTakeDevice}
                    callBackFunct={() => {
                        setOpenTakeDevice(false);
                        getData();
                    }}
                    idPermission={parseInt(params.idPermission)}
                    data={dataRef.current}
                    where='take'
                />
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('ds_lay_tb')}
                    </Typography>{' '}
                    <Button
                        variant="contained"
                        startIcon={<Iconify icon="mingcute:file-export-line" />}
                        onClick={onDownload}
                    >
                        {t('export_excel')}
                    </Button>
                </Stack>{' '}
                {!device_cd && <Breadcrumb paths={[{ label: t('ds_lay_tb'), url: '#', navigate: false }]} />}
                <Loader loading={getFlags} />
                <Card>
                    <Grid padding={'20px 10px'} container spacing={1} style={{}}>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <TextInput
                                size="medium"
                                getValue={(e) => handleOnChange(e, 'key')}
                                label={t('searchDevice')}
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <ComboBox
                                label={t('filter_status')}
                                sizeCbb="medium"
                                displayLabel="label"
                                valueEqual="value"
                                getValue={(e) => handleOnChange((e || {})['value'] || 'all', 'status')}
                                selectOption={ARR_STATUS}
                                required
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue
                                label={t('start_day')}
                                valueChange={valueSearch.current.startDay}
                                getValue={(e) => handleOnChange(e, 'startDay')}
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue
                                label={t('to_day')}
                                valueChange={valueSearch.current.toDay}
                                getValue={(e) => handleOnChange(e, 'endDay')}
                            />
                        </Grid>
                        <Grid item xl={2} md={2} sm={12} style={{ width: '100%', marginTop: 9 }}>
                            <ButtonAction
                                fullWidth
                                onClick={getData}
                                size="large"
                                type={'search'}
                                title={t('search')}
                                sx={{ padding: 3.3 }}
                            />
                        </Grid>
                    </Grid>
                    <Stack sx={{ maxHeight: '70vh' }}>
                        <TableContainer>
                            <Table>
                                <DepartmentListHead
                                    order={'asc'}
                                    orderBy={'name'}
                                    headLabel={TABLE_HEAD}
                                    rowCount={tableData.length}
                                />
                                <TableBody>
                                    {tableData.length > 0 &&
                                        tableData.map((item, index) => {
                                            return (
                                                <ItemListTakeDevice
                                                    key={index}
                                                    item={item}
                                                    index={index}
                                                    STATUS_COLOR={STATUS_COLOR}
                                                    isAdmin={isAdmin}
                                                    dataRef={dataRef}
                                                    setVisibleApprove={setVisibleApprove}
                                                    setVisibleReject={setVisibleReject}
                                                    setVisible={setVisible}
                                                    setVisibleRefund={setVisibleRefund}
                                                    setVisibleRequestFixDevice={setVisibleRequestFixDevice}
                                                    setVisibleConfirmFixDevice={setVisibleConfirmFixDevice}
                                                    openButton={true}
                                                    setOpenChangeRequestDevice={setOpenChangeRequestDevice}
                                                    setOpenTakeDevice={setOpenTakeDevice}
                                                />
                                            );
                                        })}
                                </TableBody>
                            </Table>
                            {tableData.length === 0 && <EmtyData />}
                        </TableContainer>
                        <Box
                            sx={{ position: 'sticky', zIndex: 1000, bottom: 0, backgroundColor: '#f1f3f4' }}
                            display={'flex'}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            paddingLeft={2}
                            // paddingRight={2}
                        >
                            <Stack>
                                <span>
                                    {t('total_row')}: {tableData.length}/{totalData}
                                </span>
                            </Stack>
                            <Button
                                variant="contained"
                                endIcon={<Iconify icon="material-symbols:skip-next-rounded" />}
                                onClick={() => getDataNext()}
                                disabled={tableData.length < totalData ? false : true}
                            >
                                {t('next')}
                            </Button>
                        </Box>
                    </Stack>
                    {/* table xuất excel */}
                    <TableContainer>
                        <Table ref={tableRef} sx={{ display: 'none' }}>
                            <DepartmentListHead
                                order={'asc'}
                                orderBy={'name'}
                                headLabel={TABLE_HEAD}
                                rowCount={tableData.length}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => {
                                        return (
                                            <ItemListTakeDevice
                                                key={index}
                                                item={item}
                                                index={index}
                                                STATUS_COLOR={STATUS_COLOR}
                                                isAdmin={isAdmin}
                                                dataRef={dataRef}
                                                setVisibleApprove={setVisibleApprove}
                                                setVisibleReject={setVisibleReject}
                                                setVisible={setVisible}
                                                setVisibleRefund={setVisibleRefund}
                                                setVisibleRequestFixDevice={setVisibleRequestFixDevice}
                                                setVisibleConfirmFixDevice={setVisibleConfirmFixDevice}
                                                openButton={false}
                                                setOpenChangeRequestDevice={setOpenChangeRequestDevice}
                                                setOpenTakeDevice={setOpenTakeDevice}
                                            />
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </Container>
        </>
    );
}
